import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-maintenance-shell',
  standalone: true,
  imports: [RouterModule],
  template: '<router-outlet></router-outlet>',
  styles: [':host { display: block; }']
})
export class MaintenanceShellComponent {}
